import React, { Component } from 'react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
/**
 * ErrorBoundary component
 * Catches JavaScript errors anywhere in the child component tree
 * Logs errors and displays a fallback UI
 */
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };
  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4" data-id="element-2214">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center" data-id="element-2215">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2216">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-2217">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-2218" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-2219">
              Something went wrong
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-2220">
              We're sorry for the inconvenience. Please try refreshing the page.
            </p>
            <button onClick={() => window.location.reload()} className="px-4 py-2 bg-[#3ab795] text-white rounded-lg hover:bg-[#2da07d] transition-colors" data-id="element-2221">
              Refresh Page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}